module.exports = __webpack_public_path__ + "img/voter-id-illustration.474c480c.png";